import { P } from "framer-motion/dist/types.d-D0HXPxHm"

/**
 * Convert meters to kilometers with space-separated thousands
 * @param meters - Distance in meters
 * @returns Formatted string like "492 800 km" or "-" if null/undefined
 */
export function formatDistance(meters: number | null | undefined): string {
  if (meters == null) return "-"
  const km = Math.round(meters / 1000)
  return `${km.toLocaleString("en-US").replace(/,/g, " ")} km`
}

/**
 * Convert seconds to hours and minutes format
 * @param seconds - Duration in seconds
 * @returns Formatted string like "6 274h 32m" or "-" if null/undefined
 */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return "-"
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const formattedHours = hours.toLocaleString("en-US").replace(/,/g, " ")
  return `${formattedHours}h ${minutes}m`
}

/**
 * Format currency with space-separated thousands and 2 decimal places
 * @param amount - Amount in EUR
 * @returns Formatted string like "935 739,20 EUR"
 */
export function formatCurrency(amount: number): string {
  const formatted = amount
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",")
  return `${formatted} EUR`
}

/**
 * Calculate percentage difference between two values
 * @param actual - Actual value
 * @param expected - Expected value
 * @returns Percentage difference (positive if actual > expected)
 */
export function calculatePercentageDiff(
  actual: number | null | undefined,
  expected: number | null | undefined,
): number | null {
  if (actual == null || expected == null) return null
  if (expected === 0) return 0
  return ((actual - expected) / expected) * 100
}

export function calculateDistanceDiff(
  actual: number | null | undefined,
  expected: number | null | undefined,
): string {
  if (actual == null || expected == null) return "-"
  const km_diff = Math.abs((actual - expected) / 1000)
  return `${km_diff.toLocaleString("pl-PL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })} km`
}

export function calculateTimeDiff(
  actual: number | null | undefined,
  expected: number | null | undefined,
): string {
  if (actual == null || expected == null) return "-"
  const totalSeconds = Math.abs(actual - expected)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  return `${hours}h ${minutes}m`
}

export function calculateEuroDiff(
  actual: number | null | undefined,
  expected: number | null | undefined,
): string {
  if (actual == null || expected == null) return "-"
  const euro_diff = Math.abs(actual - expected)
  const formatted = euro_diff
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    .replace(".", ",")
  return `${formatted} EUR`
}
